import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// import { useTheme } from '@material-ui/core/styles';
import './modal.css';

import MuiAlert from '@material-ui/lab/Alert';
import { useLang } from '../../util/lang';

export default function ResponsiveDialog({
    isAutoFocus = false,
    maxWidth = 'lg',
    optBtn,
    minHeight = 0,
    btnLabel = { closeBtnLabel: undefined },
    closeButtonClassName = '',
    onExited,
    saveLabel = ':const.save',
    ...props
}) {
    // 响应式弹窗组件，支持自定义关闭按钮样式。
    // const theme = useTheme();
    const get = useLang('');
    const [fullWidth, setFullWidth] = React.useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleDataSave = async () => {
        try {
            setSubmitLoading(true);
            if (props.handleDataSave && typeof props.handleDataSave === 'function') {
                await props.handleDataSave();
            }
        } catch (error) {
            console.error('Error in handleDataSave: ', error);
        } finally {
            setSubmitLoading(false);
        }
    };

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }
    if (!btnLabel.closeBtnLabel) {

        btnLabel.closeBtnLabel = get(':const.close');
    }
    return (
        <>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={props.modalSize ? props.modalSize : maxWidth}
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="responsive-dialog-title"
                TransitionProps={{ onExited }}
            >
                <DialogTitle id="responsive-dialog-title">{props.title}</DialogTitle>
                <DialogContent style={{ minHeight: minHeight }} onClick={(e) => e.stopPropagation()}>
                    {/* <DialogContentText> */}
                    {props.modalError && (
                        <Alert severity="error" style={{ marginBottom: '30px' }}>
                            {props.modalError}
                        </Alert>
                    )}
                    {props.children}
                    {/* </DialogContentText> */}
                </DialogContent>
                <DialogActions onClick={(e) => e.stopPropagation()}>
                    {optBtn && (
                        <Button
                            key={optBtn.key || 'optBtn'}
                            onClick={() => {
                                if (optBtn.onClick && typeof optBtn.onClick === 'function') {
                                    optBtn.onClick();
                                } else {
                                    console.error('Please provide onClick function for this button');
                                }
                            }}
                            disabled={optBtn.disabled || false}
                        >
                            {optBtn?.label || ''} {optBtn.icon ? optBtn.icon : null}
                        </Button>
                    )}

                    {props.handleClose && (
                        <Button
                            className={`modalCloseButton ${closeButtonClassName}`}
                            autoFocus={isAutoFocus}
                            onClick={props.handleClose}
                        >
                            {btnLabel.closeBtnLabel}
                        </Button>
                    )}
                    {props.submitButton && (
                        <Button
                            onClick={handleDataSave}
                            className="customButton"
                            autoFocus
                            disabled={props.PhotoUploadLoadingStatus || submitLoading || props.submitDisabled}
                        >
                            {props.PhotoUploadLoadingStatus
                                ? `${get(':const.saving')}...`
                                : props.submitButtonLabel
                                  ? props.submitButtonLabel
                                  : get(saveLabel)}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </>
    );
}
